"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _tableCheckboxActionButton = _interopRequireDefault(require("./tableCheckboxActionButton"));
var _axios = _interopRequireDefault(require("axios"));
var _excluded = ["onSuccess", "onFailure", "url", "axiosInstance"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var APITableCheckboxActionButton = function APITableCheckboxActionButton(_ref) {
  var onSuccess = _ref.onSuccess,
    onFailure = _ref.onFailure,
    url = _ref.url,
    _ref$axiosInstance = _ref.axiosInstance,
    axiosInstance = _ref$axiosInstance === void 0 ? _axios["default"] : _ref$axiosInstance,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var onCLick = function onCLick(ids) {
    setLoading(true);
    axiosInstance.post(url, {
      ids: ids
    }).then(function (response) {
      setLoading(false);
      if (onSuccess) {
        onSuccess(response);
      } else {
        document.location.reload();
      }
    })["catch"](function (error) {
      setLoading(false);
      if (onFailure) {
        onFailure(error);
      } else {
        alert("An error occurred.");
      }
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_tableCheckboxActionButton["default"], (0, _extends2["default"])({}, props, {
    onClick: onCLick,
    loading: loading
  }));
};
var _default = exports["default"] = APITableCheckboxActionButton;